import React from 'react';
import { OptimizedImage } from './OptimizedImage';
import type { GuidePage } from '../data/activities';
type GuidePagePreviewProps = {
  page: GuidePage;
};
export function GuidePagePreview({
  page
}: GuidePagePreviewProps) {
  return <figure className="h-full overflow-hidden rounded-2xl border border-line bg-[#1a1a1d] shadow-[0_30px_60px_-30px_rgba(0,0,0,0.8)]" data-id="element-8" data-mp="1uphidanlkh0">
      <OptimizedImage src={page.image} alt={page.alt} width={664} height={832} widths={[320, 480, 664]} sizes="(min-width: 1024px) 290px, (min-width: 640px) 45vw, 84vw" className="block h-auto w-full" data-id="element-9" data-mp="bm3mh0ldjchj" />
      <figcaption className="sr-only" data-id="element-10" data-mp="knb74fuywet5">{page.title}</figcaption>
    </figure>;
}